type TelegramWebAppUser = {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
};

type TelegramWebApp = {
  initData: string;
  initDataUnsafe: {
    user?: TelegramWebAppUser;
  };
  platform?: string;
  version?: string;
  ready: () => void;
  expand: () => void;
  setHeaderColor?: (color: string) => void;
  setBackgroundColor?: (color: string) => void;
  colorScheme?: 'light' | 'dark';
};

declare global {
  interface Window {
    Telegram?: {
      WebApp?: TelegramWebApp;
    };
  }
}

let cachedInitData = '';

export function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

export function isTelegramWebApp(): boolean {
  const webApp = getTelegramWebApp();
  if (!webApp) return false;
  if (webApp.initData) return true;
  if (webApp.initDataUnsafe?.user?.id) return true;
  const platform = webApp.platform?.toLowerCase();
  return Boolean(platform && platform !== 'unknown');
}

export function getTelegramInitData(): string {
  const live = getTelegramWebApp()?.initData ?? '';
  if (live) return live;
  return cachedInitData;
}

export function setCachedTelegramInitData(initData: string): void {
  cachedInitData = initData;
}

/** Wait for Telegram.WebApp.initData (never use URL hash — format differs). */
export async function resolveTelegramInitData(timeoutMs = 5000): Promise<string> {
  const started = Date.now();
  while (Date.now() - started < timeoutMs) {
    const live = getTelegramWebApp()?.initData ?? '';
    if (live) {
      cachedInitData = live;
      return live;
    }
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
  return getTelegramWebApp()?.initData ?? '';
}

export function initTelegramWebApp(): void {
  const webApp = getTelegramWebApp();
  if (!webApp) return;

  webApp.ready();
  webApp.expand();
  webApp.setHeaderColor?.('#0a0f1a');
  webApp.setBackgroundColor?.('#0a0f1a');
}
